<div *ngIf="!vertical; else verticalOrientation" class="parent-container">
    <div *ngIf="!currentStageOnly" class="progress-bar-outer">
        <div class="progress-bar-inner" [ngStyle]="{'width': getProgressWidth()}"></div>
    </div>
    <div class="stages-container">
        <ng-container *ngFor="let stage of stagesToRender; let i = index">
            <div class="stage-container">
                <div class="stage-circle" [ngClass]="{'filled': i <= currentStageToRender}">
                    <rms-bubble-icon [icon]="getIcon(i)"></rms-bubble-icon>
                </div>
                <div class="stage-label bold">{{stage}}</div>
            </div>
        </ng-container>
    </div>
</div>
<ng-template #verticalOrientation>
    <div class="parent-container-vertical" [ngStyle]="{'height': height + 'px'}">
        <div *ngIf="!currentStageOnly" class="progress-bar-outer-vertical">
            <div class="progress-bar-inner-vertical" [ngStyle]="{'height': getProgressWidth()}"></div>
        </div>
        <div class="stages-container-vertical">
            <ng-container *ngFor="let stage of stagesToRender; let i = index">
                <div class="stage-container-vertical">
                    <div class="stage-circle-vertical" [ngClass]="{'filled': i <= currentStageToRender}">
                        <rms-bubble-icon [icon]="getIcon(i)"></rms-bubble-icon>
                    </div>
                    <div class="stage-label-vertical">{{stage}}</div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
